import React, {useContext} from 'react';
import {SiteSettingsContext} from './SiteSettingsProvider';

export const useSiteSettings = () => {
  const siteSettings = useContext(SiteSettingsContext);
  if (!siteSettings) {
    throw new Error('Site Settings is not provided');
  }
  return siteSettings;
};
export const withSiteSettings: any = (Component) => {
  const ComponentWithSettings = ({children, ...props}) => {
    const siteSettings = useSiteSettings();
    return (
      <Component siteSettings={siteSettings} {...props}>
        {children}
      </Component>
    );
  };
  return ComponentWithSettings;
};
